<div class="container flex column justify-flex-start align-center">
  <img class="image" [src]="imagePath" />
  <span class="title">{{title}}</span>
  <span class="message" [innerHTML]="message"></span>
  <button *ngIf="showButton" mat-raised-button app-click-stop-propagation color="color-warn" class="button" [routerLink]="[buttonUrl]">
    {{buttonText}}
  </button>
</div>
